/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown>, failed: NonNullable<unknown> }} Embed_Captions_Local_Failed_TextInputs */



/**
* | output |
* | --- |
* | "Embedded {done} of {total} files. Failed: {failed}." |
*
* @param {Embed_Captions_Local_Failed_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_failed_text = /** @type {((inputs: Embed_Captions_Local_Failed_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Failed_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Fichier ${i?.done} intégré à ${i?.total}. Échec : ${i?.failed}.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Eingebettete ${i?.done} von ${i?.total} Dateien. Fehlgeschlagen: ${i?.failed}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Incorporamento del file ${i?.done} di ${i?.total}. Operazione non riuscita: ${i?.failed}.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Встроенный ${i?.done} из ${i?.total} файлов. Сбой: ${i?.failed}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Archivos ${i?.done} incrustados de ${i?.total}. Falló: ${i?.failed}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`嵌入 ${i?.total} 文件中的 ${i?.done}。失败：${i?.failed}。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.total} ファイルの ${i?.done} が埋め込まれました。失敗: ${i?.failed}。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.total} फ़ाइलों में एम्बेडेड ${i?.done}। विफल: ${i?.failed}।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Arquivos ${i?.done} incorporados de ${i?.total} falharam: ${i?.failed}.`)
	return /** @type {LocalizedString} */ (`Embedded ${i?.done} of ${i?.total} files. Failed: ${i?.failed}.`)
});